import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-psychology-lab',
  templateUrl: './psychology-lab.component.html',
  styleUrls: ['./psychology-lab.component.scss']
})
export class PsychologyLabComponent implements OnInit {
  activeLightboxImage: string | null = null;

  psychologyImages = [
    '/assets/img/facilities/imgi_452_psychology_lab_img1-1200x800.jpg',
    '/assets/img/facilities/imgi_449_psychology_lab_img2-1200x800.jpg',
    '/assets/img/facilities/imgi_440_psychology_lab_img3-1200x800.jpg',
    '/assets/img/facilities/imgi_446_psychology_lab_img4-1067x800.jpg',
    '/assets/img/facilities/imgi_443_psychology_lab_img5-1067x800.jpg'
  ];

  constructor() { }

  ngOnInit(): void { }

  openLightbox(src: string): void {
    this.activeLightboxImage = src;
  }

  closeLightbox(): void {
    this.activeLightboxImage = null;
  }
}

